import { Link, Stack, styled, useTheme } from '@mui/material'
import { useState } from 'react'
import { Imprint } from 'ComponentLibrary/src/molecules/Footer/Imprint'
import { PrivacyPolicy } from 'ComponentLibrary/src/molecules/Footer/PrivacyPolicy'
import { useFooterCopy } from 'ComponentLibrary/src/molecules/Footer/footerCopy'

export const Footer = ({ withTopSpace, showCookieSettings = true }: { withTopSpace?: boolean; showCookieSettings?: boolean }) => {
    const theme = useTheme()
    const copy = useFooterCopy()
    const [isPrivacyPolicyOpen, setIsPrivacyPolicyOpen] = useState(false)
    const [isImprintOpen, setIsImprintOpen] = useState(false)

    return (
        <>
            <Stack
                direction="row"
                gap={theme.spacing(6)}
                justifyContent="center"
                alignItems="flex-end"
                width="100%"
                padding="6px 0"
                marginTop={withTopSpace ? 'auto' : undefined}
                height={withTopSpace ? '120px' : undefined}
            >
                {showCookieSettings && <FooterLink onClick={window.CCM?.openControlPanel}>{copy.links.cookieSettings}</FooterLink>}
                <FooterLink onClick={() => setIsPrivacyPolicyOpen(true)}>{copy.links.privacyPolicy}</FooterLink>
                <FooterLink onClick={() => setIsImprintOpen(true)}>{copy.links.imprint}</FooterLink>
            </Stack>
            <PrivacyPolicy isPrivacyPolicyOpen={isPrivacyPolicyOpen} setIsPrivacyPolicyOpen={setIsPrivacyPolicyOpen} />
            <Imprint isImprintOpen={isImprintOpen} setIsImprintOpen={setIsImprintOpen} />
        </>
    )
}

const FooterLink = styled(Link)(({ theme }) => ({
    color: theme.palette.customtext.black38,
    textDecoration: 'none',
    ...theme.typography.bodyTextSmall,
    '&:hover': {
        textDecoration: 'underline',
    },
    cursor: 'pointer',
}))
